
// import React, { useState, useEffect } from 'react';
// import { getJobs } from "./jobService";
// import { getCategories } from "./categoryService";

// const API_URL = process.env.REACT_APP_API_URL;

// function Reports({ onLogout }) {
//   const storedUser = localStorage.getItem("user");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const organizationName = user?.organization_name || "Organization";

//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [jobs, setJobs] = useState([]);
  
//   // Loading & Streaming States
//   const [loadingJobs, setLoadingJobs] = useState(false);
//   const [isBackgroundFetching, setIsBackgroundFetching] = useState(false);
//   const [fetchedPagesCount, setFetchedPagesCount] = useState(0);

//   // Search State (Instant Filter)
//   const [searchQuery, setSearchQuery] = useState('');

//   // Date Filtering States
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const [jobsPerPage, setJobsPerPage] = useState(100);

//   const [targetJobDropdown, setTargetJobDropdown] = useState('');
//   const [checkedJobIds, setCheckedJobIds] = useState([]);
//   const [imagesPerRow, setImagesPerRow] = useState(3);
//   const [reportType, setReportType] = useState("single");
//   const [isCompiling, setIsCompiling] = useState(false);
//   const [finishedReports, setFinishedReports] = useState([]);

//   useEffect(() => {
//     const loadCategories = async () => {
//       try {
//         const data = await getCategories();
//         const loadedCategories = data.data || data;

//         const sortedCategories = [...loadedCategories].sort((a, b) =>
//           a.name.trim().localeCompare(b.name.trim(), undefined, {
//             sensitivity: "base",
//           })
//         );

//         setCategories(sortedCategories);
//       } catch (error) {
//         console.error("Failed to fetch categories:", error);
//       }
//     };

//     loadCategories();
//   }, []);

//   useEffect(() => {
//     let isSubscribed = true;

//     // Don't load any jobs until a category is selected
//     if (!selectedCategory) {
//       setJobs([]);
//       setCheckedJobIds([]);
//       setTargetJobDropdown("");
//       setLoadingJobs(false);
//       setIsBackgroundFetching(false);
//       setFetchedPagesCount(0);
//       return;
//     }

//     const loadJobs = async () => {
//       try {
//         setLoadingJobs(true);
//         setIsBackgroundFetching(true);
//         setFetchedPagesCount(0);
//         setJobs([]);

//         await getJobs(selectedCategory, (accumulatedJobs, pageNum, isLastPage) => {
//           if (!isSubscribed) return;

//           setJobs(accumulatedJobs);
//           setFetchedPagesCount(pageNum);

//           if (pageNum === 1) {
//             setLoadingJobs(false);
//           }

//           if (isLastPage) {
//             setIsBackgroundFetching(false);
//           }
//         });
//       } catch (err) {
//         console.error(err);
//       } finally {
//         if (isSubscribed) {
//           setLoadingJobs(false);
//           setIsBackgroundFetching(false);
//         }
//       }
//     };

//     loadJobs();

//     return () => {
//       isSubscribed = false;
//     };
//   }, [selectedCategory]);

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   // Client-side instant date and Job ID search filtering
//   const filteredJobs = jobs.filter((job) => {
//     // Instant Live Search Filter
//     if (searchQuery.trim() !== '') {
//       const query = searchQuery.trim().toLowerCase();
//       const matchId = String(job.id).toLowerCase().includes(query);
//       const matchSnap = job.snapJobId ? String(job.snapJobId).toLowerCase().includes(query) : false;
//       const matchTitle = job.title ? job.title.toLowerCase().includes(query) : false;

//       if (!matchId && !matchSnap && !matchTitle) return false;
//     }

//     // Date filters
//     if (!fromDate && !toDate) return true;
//     if (!job.completedAt) return false;

//     const jobDate = new Date(job.completedAt);

//     if (fromDate && jobDate < new Date(fromDate)) return false;

//     if (toDate) {
//       const end = new Date(toDate);
//       end.setHours(23, 59, 59, 999);
//       if (jobDate > end) return false;
//     }

//     return true;
//   });

//   // Dynamic Pagination calculations
//   const totalPages = Math.max(1, Math.ceil(filteredJobs.length / jobsPerPage));
//   const startIndex = (currentPage - 1) * jobsPerPage;
//   const endIndex = startIndex + jobsPerPage;
//   const paginatedJobs = filteredJobs.slice(startIndex, endIndex);
//   const showingFrom = filteredJobs.length === 0 ? 0 : startIndex + 1;
//   const showingTo = Math.min(endIndex, filteredJobs.length);

//   const handlePageChange = (newPage) => {
//     const validPage = Math.max(1, Math.min(newPage, totalPages));
//     setCurrentPage(validPage);
//     document.querySelector(".scrollable-jobs-panel")?.scrollTo({
//       top: 0,
//       behavior: "smooth"
//     });
//   };

//   const toggleCheckbox = (id) => {
//     setCheckedJobIds((prev) =>
//       prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
//     );
//   };

//   const handleSelectAll = () => {
//     setCheckedJobIds(paginatedJobs.map((job) => job.id));
//   };

//   const handleClearAll = () => {
//     setCheckedJobIds([]);
//   };

//   const executeReportGeneration = async () => {
//     const activeIds = checkedJobIds.length > 0 
//       ? checkedJobIds 
//       : (targetJobDropdown ? [parseInt(targetJobDropdown)] : []);

//     if (activeIds.length === 0) {
//       alert('Please select at least one job to generate reports.');
//       return;
//     }

//     const targetPayloads = activeIds.map((selectedId) => {
//       const jobObj = jobs.find((j) => j.id === selectedId);
//       return {
//         id: jobObj.id,
//         message_job_id: jobObj.messageJobId,
//         completed_at: jobObj.completedAt
//       };
//     });

//     setIsCompiling(true);
//     setFinishedReports([]);

//     try {
//       if (reportType === "single") {
//         const response = await fetch(`${API_URL}/api/reports/generate-combined`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${localStorage.getItem("jwt")}`
//           },
//           body: JSON.stringify({
//             jobs: targetPayloads,
//             category_id: selectedCategory ? parseInt(selectedCategory) : null,
//             images_per_row: imagesPerRow
//           })
//         });

//         const result = await response.json();
//         if (result.success) {
//             setFinishedReports([result]);
//         } else {
//             console.error("Backend report error:", result);
//             alert(`Failed to build combined document.\n\n${result.error || "Unknown backend error"}`);
//         }

//       } else {
//         const operations = targetPayloads.map(async (target) => {
//           const response = await fetch(`${API_URL}/api/reports/generate`, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Authorization': `Bearer ${localStorage.getItem("jwt")}`
//             },
//             body: JSON.stringify({
//               id: target.id,
//               message_job_id: target.message_job_id,
//               completed_at: target.completed_at,
//               category_id: selectedCategory ? parseInt(selectedCategory) : null,
//               images_per_row: imagesPerRow
//             })
//           });
//           return response.json();
//         });

//         const responses = await Promise.all(operations);
//         const successfulBuilds = responses.filter((res) => res.success);

//         if (successfulBuilds.length > 0) {
//           setFinishedReports(successfulBuilds);
//         } else {
//           alert('Document generation operations failed.');
//         }
//       }
//     } catch (error) {
//       console.error('Report compilation error:', error);
//       alert('Network or backend server connectivity error.');
//     } finally {
//       setIsCompiling(false);
//     }
//   };

//   const selectedJobs = checkedJobIds.length;

//   return (
//     <div className="dashboard-canvas">
//       {/* Top Header */}
//       <header className="dashboard-header">
//         <div className="organization-name">
//           {organizationName}
//         </div>

//         <h1>Create Report — Screen Layout Workspace</h1>
//       </header>

//       {/* Row 1: Target Controls & Date Filtering */}
//       <div className="top-controls-row">
//         <div className="input-group">
//           <label>Job Category</label>
//           <select 
//             value={selectedCategory} 
//             onChange={(e) => {
//               setSelectedCategory(e.target.value);
//               setTargetJobDropdown('');
//               setCheckedJobIds([]);
//               setCurrentPage(1);
//             }}
//           >
//             <option value="">Select Category</option>
//             {categories.map((category) => (
//               <option key={category.id} value={category.id}>
//                 {category.attributes?.name || category.name || `Category #${category.id}`}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="input-group">
//           <label>From Date</label>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => {
//               setFromDate(e.target.value);
//               setTargetJobDropdown('');
//               setCheckedJobIds([]);
//               setCurrentPage(1);
//             }}
//           />
//         </div>

//         <div className="input-group">
//           <label>To Date</label>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => {
//               setToDate(e.target.value);
//               setTargetJobDropdown('');
//               setCheckedJobIds([]);
//               setCurrentPage(1);
//             }}
//           />
//         </div>

//         <div className="input-group">
//           <label>Target Job Entity</label>
//           <select 
//             value={targetJobDropdown} 
//             onChange={(e) => setTargetJobDropdown(e.target.value)}
//           >
//             <option value="">Select Job</option>
//             {paginatedJobs.map((job) => (
//               <option key={job.id} value={job.id}>
//                 {job.snapJobId ? `${job.snapJobId} - ${job.title}` : `Job #${job.id}`}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Row 2: Settings & Multi-Selection Split */}
//       <div className="middle-settings-split">
//         {/* Left Section: Jobs Selection */}
//         <div className="content-column job-matrix-column">
//           <div className="section-header">
//             <div className="section-header-title-group" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//               <span className="section-label">Target Multi-Selection Matrix</span>

//               {/* Instant Search Input */}
//               <input
//                 type="text"
//                 placeholder="Search Job ID..."
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//                 className="search-job-input"
//                 style={{
//                   padding: '4px 10px',
//                   borderRadius: '6px',
//                   border: '1px solid var(--border-color, #d0d7de)',
//                   fontFamily: 'inherit',
//                   fontSize: '0.85rem',
//                   color: 'inherit',
//                   backgroundColor: 'var(--bg-input, #ffffff)',
//                   outline: 'none'
//                 }}
//               />

//               {/* Loader Circle */}
//               {(isBackgroundFetching || loadingJobs) && (
//                 <div className="job-fetch-spinner" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <div 
//                     className="spinner-icon" 
//                     style={{
//                       width: '14px',
//                       height: '14px',
//                       border: '2px solid var(--border-color, #e1e4e8)',
//                       borderTop: '2px solid var(--accent-color, #0969da)',
//                       borderRadius: '50%',
//                       animation: 'spin 0.8s linear infinite'
//                     }} 
//                   />
//                   <span 
//                     className="live-stream-badge" 
//                     style={{ 
//                       fontSize: '0.8rem', 
//                       color: 'var(--dash-text-sub, #57606a)',
//                       fontFamily: 'inherit'
//                     }}
//                   >
//                     Fetching Page {fetchedPagesCount}... ({jobs.length} jobs)
//                   </span>
//                 </div>
//               )}
//             </div>

//             <div className="selection-actions">
//               <span className="job-counter">
//                 Selected: {selectedJobs} | Showing {showingFrom}-{showingTo} of {filteredJobs.length} jobs
//               </span>

//               {/* Jobs Per Page Dropdown */}
//               <select
//                 value={jobsPerPage}
//                 onChange={(e) => {
//                   setJobsPerPage(Number(e.target.value));
//                   setCurrentPage(1);
//                   setCheckedJobIds([]);
//                 }}
//                 className="jobs-per-page-select"
//               >
//                 <option value={50}>50 / page</option>
//                 <option value={100}>100 / page</option>
//                 <option value={200}>200 / page</option>
//               </select>
//               <button
//                 type="button"
//                 className="btn-select-all"
//                 onClick={handleSelectAll}
//               >
//                 Select All
//               </button>

//               <button
//                 type="button"
//                 className="btn-clear-all"
//                 onClick={handleClearAll}
//               >
//                 Clear
//               </button>
//             </div>
//           </div>
          
//           <div className="scrollable-jobs-panel">
//             {loadingJobs ? (
//               <div className="loading-jobs-spinner">
//                 <div className="spinner-icon"></div>
//                 <span>Fetching jobs... (Page 1)</span>
//               </div>
//             ) : paginatedJobs.length === 0 ? (
//               <div style={{ padding: '1rem', color: 'var(--dash-text-sub)', textAlign: 'center' }}>
//                 No jobs match the selected filters.
//               </div>
//             ) : (
//               paginatedJobs.map((job) => (
//                 <label key={job.id} className="job-checkbox-wrapper">
//                   <input
//                     type="checkbox"
//                     checked={checkedJobIds.includes(job.id)}
//                     onChange={() => toggleCheckbox(job.id)}
//                   />
//                   <span>{job.snapJobId ? `${job.snapJobId} - ${job.title}` : `Job #${job.id}`}</span>
//                 </label>
//               ))
//             )}
//           </div>

//           {/* Pagination Navigation Bar */}
//           <div className="pagination-controls">
//             <div className="nav-btn-group">
//               <button
//                 type="button"
//                 className="btn-page-step"
//                 disabled={currentPage === 1}
//                 onClick={() => handlePageChange(1)}
//                 title="First Page"
//               >
//                 &laquo;
//               </button>
//               <button
//                 type="button"
//                 className="btn-page-step"
//                 disabled={currentPage === 1}
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 title="Previous Page"
//               >
//                 &lt;
//               </button>
//             </div>

//             <div className="page-jump-container">
//               <span>Page</span>
//               <input
//                 type="number"
//                 min={1}
//                 max={totalPages}
//                 value={currentPage}
//                 onChange={(e) => {
//                   const val = Number(e.target.value);
//                   if (val >= 1 && val <= totalPages) {
//                     handlePageChange(val);
//                   }
//                 }}
//                 className="page-number-input"
//               />
//               <span>of {totalPages}</span>
//             </div>

//             <div className="nav-btn-group">
//               <button
//                 type="button"
//                 className="btn-page-step"
//                 disabled={currentPage === totalPages}
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 title="Next Page"
//               >
//                 &gt;
//               </button>
//               <button
//                 type="button"
//                 className="btn-page-step"
//                 disabled={currentPage === totalPages}
//                 onClick={() => handlePageChange(totalPages)}
//                 title="Last Page"
//               >
//                 &raquo;
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Right Section: Combined Report Options Column */}
//         <div className="content-column report-config-column">
//           <div className="config-card">
//             <div className="images-per-row-section">
//               <span className="section-label">Images Per Row</span>
//               <div className="image-row-toggle-strip">
//                 {[1, 2, 3, 4].map((num) => (
//                   <button
//                     key={num}
//                     type="button"
//                     className={`toggle-block-btn ${imagesPerRow === num ? 'active' : ''}`}
//                     onClick={() => setImagesPerRow(num)}
//                   >
//                     {num}
//                   </button>
//                 ))}
//               </div>
//             </div>
//             <span className="section-label">Report Type</span>
//             <div className="report-type-options">
//               <label className="report-option">
//                 <input
//                   type="radio"
//                   name="reportType"
//                   value="single"
//                   checked={reportType === "single"}
//                   onChange={() => setReportType("single")}
//                 />
//                 Single DOC (Combine selected jobs)
//               </label>

//               <label className="report-option">
//                 <input
//                   type="radio"
//                   name="reportType"
//                   value="multiple"
//                   checked={reportType === "multiple"}
//                   onChange={() => setReportType("multiple")}
//                 />
//                 Multiple DOCs (One report per job)
//               </label>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Row 3: Actions Deck */}
//       <footer className="bottom-actions-deck">
//         <button
//           className="btn-generate-report"
//           onClick={executeReportGeneration}
//           disabled={isCompiling}
//         >
//           {isCompiling ? 'Generating...' : 'Create Report'}
//         </button>

//         {finishedReports.length > 0 && (
//           <div className="toast-output-stream">
//             {finishedReports.map((report, idx) => (
//               <div key={idx} className="toast-item">
//                 <span>Success: <strong>{report.filename}</strong> is compiled.</span>
//                 <a 
//                   href={`${API_URL}${report.download_url}`}
//                   className="download-link" 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                 >
//                   Download File
//                 </a>
//               </div>
//             ))}
//           </div>
//         )}
//       </footer>
//     </div>
//   );
// }

// export default Reports; 

import React, { useState, useEffect } from 'react';
import { getJobs } from "./jobService";
import { getCategories } from "./categoryService";

const API_URL = process.env.REACT_APP_API_URL;

function Reports({ onLogout }) {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [jobs, setJobs] = useState([]);
  
  // Loading & Streaming States
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [isBackgroundFetching, setIsBackgroundFetching] = useState(false);
  const [fetchedPagesCount, setFetchedPagesCount] = useState(0);

  // Search State (Instant Filter)
  const [searchQuery, setSearchQuery] = useState('');

  // Date Filtering States
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage, setJobsPerPage] = useState(100);

  const [targetJobDropdown, setTargetJobDropdown] = useState('');
  const [checkedJobIds, setCheckedJobIds] = useState([]);
  const [imagesPerRow, setImagesPerRow] = useState(3);
  const [reportType, setReportType] = useState("single");
  const [isCompiling, setIsCompiling] = useState(false);
  const [finishedReports, setFinishedReports] = useState([]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await getCategories();
        const loadedCategories = data.data || data;

        const sortedCategories = [...loadedCategories].sort((a, b) =>
          a.name.trim().localeCompare(b.name.trim(), undefined, {
            sensitivity: "base",
          })
        );

        setCategories(sortedCategories);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    loadCategories();
  }, []);

  useEffect(() => {
    let isSubscribed = true;

    // Don't load any jobs until a category is selected
    if (!selectedCategory) {
      setJobs([]);
      setCheckedJobIds([]);
      setTargetJobDropdown("");
      setLoadingJobs(false);
      setIsBackgroundFetching(false);
      setFetchedPagesCount(0);
      return;
    }

    const loadJobs = async () => {
      try {
        setLoadingJobs(true);
        setIsBackgroundFetching(true);
        setFetchedPagesCount(0);
        setJobs([]);

        await getJobs(selectedCategory, (accumulatedJobs, pageNum, isLastPage) => {
          if (!isSubscribed) return;

          setJobs(accumulatedJobs);
          setFetchedPagesCount(pageNum);

          if (pageNum === 1) {
            setLoadingJobs(false);
          }

          if (isLastPage) {
            setIsBackgroundFetching(false);
          }
        });
      } catch (err) {
        console.error(err);
      } finally {
        if (isSubscribed) {
          setLoadingJobs(false);
          setIsBackgroundFetching(false);
        }
      }
    };

    loadJobs();

    return () => {
      isSubscribed = false;
    };
  }, [selectedCategory]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Client-side instant date and Job ID search filtering
  const filteredJobs = jobs.filter((job) => {
    // Instant Live Search Filter
    if (searchQuery.trim() !== '') {
      const query = searchQuery.trim().toLowerCase();
      const matchId = String(job.id).toLowerCase().includes(query);
      const matchSnap = job.snapJobId ? String(job.snapJobId).toLowerCase().includes(query) : false;
      const matchTitle = job.title ? job.title.toLowerCase().includes(query) : false;

      if (!matchId && !matchSnap && !matchTitle) return false;
    }

    // Date filters
    if (!fromDate && !toDate) return true;
    if (!job.completedAt) return false;

    const jobDate = new Date(job.completedAt);

    if (fromDate && jobDate < new Date(fromDate)) return false;

    if (toDate) {
      const end = new Date(toDate);
      end.setHours(23, 59, 59, 999);
      if (jobDate > end) return false;
    }

    return true;
  });

  // Dynamic Pagination calculations
  const totalPages = Math.max(1, Math.ceil(filteredJobs.length / jobsPerPage));
  const startIndex = (currentPage - 1) * jobsPerPage;
  const endIndex = startIndex + jobsPerPage;
  const paginatedJobs = filteredJobs.slice(startIndex, endIndex);
  const showingFrom = filteredJobs.length === 0 ? 0 : startIndex + 1;
  const showingTo = Math.min(endIndex, filteredJobs.length);

  const handlePageChange = (newPage) => {
    const validPage = Math.max(1, Math.min(newPage, totalPages));
    setCurrentPage(validPage);
    document.querySelector(".scrollable-jobs-panel")?.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const toggleCheckbox = (id) => {
    setCheckedJobIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    setCheckedJobIds(paginatedJobs.map((job) => job.id));
  };

  const handleClearAll = () => {
    setCheckedJobIds([]);
  };

  const executeReportGeneration = async () => {
    const activeIds = checkedJobIds.length > 0 
      ? checkedJobIds 
      : (targetJobDropdown ? [parseInt(targetJobDropdown)] : []);

    if (activeIds.length === 0) {
      alert('Please select at least one job to generate reports.');
      return;
    }

    const targetPayloads = activeIds.map((selectedId) => {
      const jobObj = jobs.find((j) => j.id === selectedId);
      return {
        id: jobObj.id,
        message_job_id: jobObj.messageJobId,
        completed_at: jobObj.completedAt
      };
    });

    setIsCompiling(true);
    setFinishedReports([]);

    try {
      if (reportType === "single") {
        const response = await fetch(`${API_URL}/api/reports/generate-combined`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt")}`
          },
          body: JSON.stringify({
            jobs: targetPayloads,
            category_id: selectedCategory ? parseInt(selectedCategory) : null,
            images_per_row: imagesPerRow
          })
        });

        const result = await response.json();
        if (result.success) {
            setFinishedReports([result]);
        } else {
            console.error("Backend report error:", result);
            alert(`Failed to build combined document.\n\n${result.error || "Unknown backend error"}`);
        }

      } else {
        const operations = targetPayloads.map(async (target) => {
          const response = await fetch(`${API_URL}/api/reports/generate`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem("jwt")}`
            },
            body: JSON.stringify({
              id: target.id,
              message_job_id: target.message_job_id,
              completed_at: target.completed_at,
              category_id: selectedCategory ? parseInt(selectedCategory) : null,
              images_per_row: imagesPerRow
            })
          });
          return response.json();
        });

        const responses = await Promise.all(operations);
        const successfulBuilds = responses.filter((res) => res.success);

        if (successfulBuilds.length > 0) {
          setFinishedReports(successfulBuilds);
        } else {
          alert('Document generation operations failed.');
        }
      }
    } catch (error) {
      console.error('Report compilation error:', error);
      alert('Network or backend server connectivity error.');
    } finally {
      setIsCompiling(false);
    }
  };

  const selectedJobs = checkedJobIds.length;

  return (
    <div className="reports-page dashboard-canvas">
      {/* Row 1: Target Controls & Date Filtering */}
      <div className="top-controls-row">
        <div className="input-group">
          <label>Job Category</label>
          <select 
            value={selectedCategory} 
            onChange={(e) => {
              setSelectedCategory(e.target.value);
              setTargetJobDropdown('');
              setCheckedJobIds([]);
              setCurrentPage(1);
            }}
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.attributes?.name || category.name || `Category #${category.id}`}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <label>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              setTargetJobDropdown('');
              setCheckedJobIds([]);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="input-group">
          <label>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              setTargetJobDropdown('');
              setCheckedJobIds([]);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="input-group">
          <label>Target Job Entity</label>
          <select 
            value={targetJobDropdown} 
            onChange={(e) => setTargetJobDropdown(e.target.value)}
          >
            <option value="">Select Job</option>
            {paginatedJobs.map((job) => (
              <option key={job.id} value={job.id}>
                {job.snapJobId ? `${job.snapJobId} - ${job.title}` : `Job #${job.id}`}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Row 2: Settings & Multi-Selection Split */}
      <div className="middle-settings-split">
        {/* Left Section: Jobs Selection */}
        <div className="content-column job-matrix-column">
          <div className="section-header">
            <div className="section-header-title-group" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span className="section-label">Target Multi-Selection Matrix</span>

              {/* Instant Search Input */}
              <input
                type="text"
                placeholder="Search Job ID..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="search-job-input"
                style={{
                  padding: '4px 10px',
                  borderRadius: '6px',
                  border: '1px solid var(--border-color, #d0d7de)',
                  fontFamily: 'inherit',
                  fontSize: '0.85rem',
                  color: 'inherit',
                  backgroundColor: 'var(--bg-input, #ffffff)',
                  outline: 'none'
                }}
              />

              {/* Loader Circle */}
              {(isBackgroundFetching || loadingJobs) && (
                <div className="job-fetch-spinner" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div 
                    className="spinner-icon" 
                    style={{
                      width: '14px',
                      height: '14px',
                      border: '2px solid var(--border-color, #e1e4e8)',
                      borderTop: '2px solid var(--accent-color, #0969da)',
                      borderRadius: '50%',
                      animation: 'spin 0.8s linear infinite'
                    }} 
                  />
                  <span 
                    className="live-stream-badge" 
                    style={{ 
                      fontSize: '0.8rem', 
                      color: 'var(--dash-text-sub, #57606a)',
                      fontFamily: 'inherit'
                    }}
                  >
                    Fetching Page {fetchedPagesCount}... ({jobs.length} jobs)
                  </span>
                </div>
              )}
            </div>

            <div className="selection-actions">
              <span className="job-counter">
                Selected: {selectedJobs} | Showing {showingFrom}-{showingTo} of {filteredJobs.length} jobs
              </span>

              {/* Jobs Per Page Dropdown */}
              <select
                value={jobsPerPage}
                onChange={(e) => {
                  setJobsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                  setCheckedJobIds([]);
                }}
                className="jobs-per-page-select"
              >
                <option value={50}>50 / page</option>
                <option value={100}>100 / page</option>
                <option value={200}>200 / page</option>
              </select>
              <button
                type="button"
                className="btn-select-all"
                onClick={handleSelectAll}
              >
                Select All
              </button>

              <button
                type="button"
                className="btn-clear-all"
                onClick={handleClearAll}
              >
                Clear
              </button>
            </div>
          </div>
          
          <div className="scrollable-jobs-panel">
            {loadingJobs ? (
              <div className="loading-jobs-spinner">
                <div className="spinner-icon"></div>
                <span>Fetching jobs... (Page 1)</span>
              </div>
            ) : paginatedJobs.length === 0 ? (
              <div style={{ padding: '1rem', color: 'var(--dash-text-sub)', textAlign: 'center' }}>
                No jobs match the selected filters.
              </div>
            ) : (
              paginatedJobs.map((job) => (
                <label key={job.id} className="job-checkbox-wrapper">
                  <input
                    type="checkbox"
                    checked={checkedJobIds.includes(job.id)}
                    onChange={() => toggleCheckbox(job.id)}
                  />
                  <span>{job.snapJobId ? `${job.snapJobId} - ${job.title}` : `Job #${job.id}`}</span>
                </label>
              ))
            )}
          </div>

          {/* Pagination Navigation Bar */}
          <div className="pagination-controls">
            <div className="nav-btn-group">
              <button
                type="button"
                className="btn-page-step"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(1)}
                title="First Page"
              >
                &laquo;
              </button>
              <button
                type="button"
                className="btn-page-step"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
                title="Previous Page"
              >
                &lt;
              </button>
            </div>

            <div className="page-jump-container">
              <span>Page</span>
              <input
                type="number"
                min={1}
                max={totalPages}
                value={currentPage}
                onChange={(e) => {
                  const val = Number(e.target.value);
                  if (val >= 1 && val <= totalPages) {
                    handlePageChange(val);
                  }
                }}
                className="page-number-input"
              />
              <span>of {totalPages}</span>
            </div>

            <div className="nav-btn-group">
              <button
                type="button"
                className="btn-page-step"
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
                title="Next Page"
              >
                &gt;
              </button>
              <button
                type="button"
                className="btn-page-step"
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(totalPages)}
                title="Last Page"
              >
                &raquo;
              </button>
            </div>
          </div>
        </div>

        {/* Right Section: Combined Report Options Column */}
        <div className="content-column report-config-column">
          <div className="config-card">
            <div className="images-per-row-section">
              <span className="section-label">Images Per Row</span>
              <div className="image-row-toggle-strip">
                {[1, 2, 3, 4].map((num) => (
                  <button
                    key={num}
                    type="button"
                    className={`toggle-block-btn ${imagesPerRow === num ? 'active' : ''}`}
                    onClick={() => setImagesPerRow(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
            </div>
            <span className="section-label">Report Type</span>
            <div className="report-type-options">
              <label className="report-option">
                <input
                  type="radio"
                  name="reportType"
                  value="single"
                  checked={reportType === "single"}
                  onChange={() => setReportType("single")}
                />
                Single DOC (Combine selected jobs)
              </label>

              <label className="report-option">
                <input
                  type="radio"
                  name="reportType"
                  value="multiple"
                  checked={reportType === "multiple"}
                  onChange={() => setReportType("multiple")}
                />
                Multiple DOCs (One report per job)
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Row 3: Actions Deck */}
      <footer className="bottom-actions-deck">
        <button
          className="btn-generate-report"
          onClick={executeReportGeneration}
          disabled={isCompiling}
        >
          {isCompiling ? 'Generating...' : 'Create Report'}
        </button>

        {finishedReports.length > 0 && (
          <div className="toast-output-stream">
            {finishedReports.map((report, idx) => (
              <div key={idx} className="toast-item">
                <span>Success: <strong>{report.filename}</strong> is compiled.</span>
                <a 
                  href={`${API_URL}${report.download_url}`}
                  className="download-link" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Download File
                </a>
              </div>
            ))}
          </div>
        )}
      </footer>
    </div>
  );
}

export default Reports;